import { render, staticRenderFns } from "./StudentLeaveSettings.vue?vue&type=template&id=b5787636&scoped=true"
import script from "./StudentLeaveSettings.vue?vue&type=script&lang=js"
export * from "./StudentLeaveSettings.vue?vue&type=script&lang=js"
import style0 from "./StudentLeaveSettings.vue?vue&type=style&index=0&id=b5787636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5787636",
  null
  
)

export default component.exports